<nz-spin [nzSpinning]="loading">
  <div class="register-container">
    <nz-card *ngIf="isDataLoaded">
      <nz-tabset nzType="card" [(nzSelectedIndex)]="activeTab">
        <!-- Tab 0: 一般厂商 (保留原始内容) -->
        <nz-tab nzTitle="{{ 'VendorRegister' | translate }}">
          <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()" class="register-form">
            <div class="move-right-container">
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'VendorMobile' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                  <input formControlName="phoneNumber" nz-input class="full-width-other" />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'VendorCode' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="{{ 'InvalidVendorCode' | translate }}">
                  <input nz-input formControlName="vendorCode" placeholder="{{'VendorLimit'|translate}}"
                    class="full-width-other" (blur)="lookupVendorName()"
                    (keydown.enter)="lookupVendorName(); $event.preventDefault()" />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item *ngIf="vendorName">
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'table.VendorName' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                  <span>{{ vendorName }}</span>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'SupplierContact' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please input the supplier contact!">
                  <input nz-input formControlName="vendorContact" class="full-width-other" />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'VendorMail' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="The input is not a valid E-mail!">
                  <input nz-input formControlName="email" class="full-width-other"
                    placeholder="{{'EmailLimit'|translate}}" />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'Site' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please input the Site !">
                  <nz-select formControlName="Site" class="full-width" (ngModelChange)="getCompanyCodeList($event)">
                    <nz-option *ngFor="let option of SiteList" [nzLabel]="option.siteName"
                      [nzValue]="option"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'CompanyCode' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please input the company code!">
                  <nz-select formControlName="companyCode" nzMode="multiple" class="full-width">
                    <nz-option *ngFor="let option of CompanyCodeList" [nzLabel]="option.legalcode"
                      [nzValue]="option.legalcode"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'VendorGroup' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please input the vendorGroup!">
                  <nz-select formControlName="vendorGroup" nzMode="multiple" class="full-width">
                    <nz-option *ngFor="let option of VendorGroupList" [nzLabel]="option.typeName"
                      [nzValue]="option.type"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon></nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                  <button nz-button nzSize="large" nzType="primary" class="custom-submit-button">{{ 'Submit' | translate
                    }}</button>
                </nz-form-control>
              </nz-form-item>
            </div>
          </form>
        </nz-tab>

        <!-- Tab 1: 一般客户 (无公司别与供应商群组) -->
        <nz-tab nzTitle="{{ 'CustomerRegister' | translate }}">
          <form nz-form [formGroup]="customerForm" (ngSubmit)="submitCustomerForm()" class="register-form">
            <div class="move-right-container">
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'CustomerCode' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="{{ 'EnterCustomerCode' | translate }}">
                  <input formControlName="customerCode" nz-input class="full-width-other"
                    (blur)="lookupCustomerVendorName()"
                    (keydown.enter)="lookupCustomerVendorName(); $event.preventDefault()" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item *ngIf="customerVendorName">
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'table.VendorName' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                  <span>{{ customerVendorName }}</span>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'CustomerMobile' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                  <input formControlName="phoneNumber" nz-input class="full-width-other" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'CustomerContact' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="{{ 'EnterCustomerContact' | translate }}">
                  <input formControlName="customerContact" nz-input class="full-width-other" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'CustomerMail' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="{{ 'EnterEmail' | translate }}">
                  <input formControlName="email" nz-input class="full-width-other" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'Site' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="请选择站点">
                  <nz-select formControlName="Site" class="full-width">
                    <nz-option *ngFor="let option of SiteList" [nzLabel]="option.siteName"
                      [nzValue]="option"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon></nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                  <button nz-button nzSize="large" nzType="primary" class="custom-submit-button">{{ 'Submit' | translate
                    }}</button>
                </nz-form-control>
              </nz-form-item>
            </div>
          </form>
        </nz-tab>

        <!-- Tab 2: 来宾供应商注册（後續可替換為 wmsm-GuestVendor 组件） -->
        <nz-tab nzTitle="{{ 'GuestVendorRegister' | translate }}">
          <div class="register-form move-right-container">
            <!-- 来宾供应商表单（内联显示） -->
            <form nz-form class="vendor-form guest-vendor-form">
              <!-- <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'table.GuestVendorCode' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                  <div style="display:flex; gap:8px; align-items:center; width:100%;">
                    <input [(ngModel)]="guestVendorSearchCode" name="guestVendorSearchCode" nz-input class="full-width-other" />
                    <button nz-button nzType="default" type="button" (click)="searchGuestVendorByCode()"
                      [disabled]="loading">{{ 'Query' | translate }}</button>
                  </div>
                </nz-form-control>
              </nz-form-item> -->

              <!-- Vendor Name -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="vendorName" nzRequired>{{ 'table.VendorName' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input nz-input id="vendorName" placeholder="{{ 'table.VendorName' | translate }}" />

                </nz-form-control>
              </nz-form-item>

              <!-- Background -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">
                  {{ 'table.Background' | translate }}

                  <span nz-tooltip nzTooltipTitle="{{ 'BackgroundTip' | translate }}" nz-icon nzType="info-circle"
                    nzTheme="twotone"></span>

                </nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input nz-input id="background" placeholder="{{ 'table.Background' | translate }}" />

                </nz-form-control>
              </nz-form-item>


              <!-- Vendor Address -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">{{ 'table.VendorAddress' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input nz-input id="vendorAddress" placeholder="{{ 'table.VendorAddress' | translate }}" />
                </nz-form-control>
              </nz-form-item>


              <!-- Contact Position -->
              <!-- <nz-form-item>
                      <nz-form-label [nzSm]="6" [nzXs]="24">{{ 'table.ContactPosition' | translate }}</nz-form-label>
                      <nz-form-control [nzSm]="14" [nzXs]="24">
                        <input nz-input formControlName="contactPosition" id="contactPosition" placeholder="{{ 'table.ContactPosition' | translate }}" />
                      </nz-form-control>
                    </nz-form-item> -->

              <!-- Contact Chinese Name -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">{{ 'table.ContactChineseName' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input nz-input id="contactChineseName" placeholder="{{ 'table.ContactChineseName' | translate }}" />
                </nz-form-control>
              </nz-form-item>

              <!-- Contact English Name -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="contactEnglishName" nzRequired>{{
                  'table.ContactEnglishName' |
                  translate }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input nz-input id="contactEnglishName" placeholder="{{ 'table.ContactEnglishName' | translate }}" />
                </nz-form-control>
              </nz-form-item>

               <!-- Contact Mobile -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="contactMobile">{{ 'table.ContactMobile' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input nz-input id="contactMobile" placeholder="{{ 'table.ContactMobile' | translate }}" />
                </nz-form-control>
              </nz-form-item>

              <!-- Contact Email -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="contactEmail" nzRequired>{{ 'table.ContactEmail' |
                  translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input nz-input id="contactEmail" placeholder="{{ 'table.ContactEmail' | translate }}" />
                </nz-form-control>
              </nz-form-item>

              <!-- Contact Company Phone -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">{{ 'table.ContactCompanyPhone' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input nz-input id="contactCompanyPhone"
                    placeholder="{{ 'table.ContactCompanyPhone' | translate }}" />
                </nz-form-control>
              </nz-form-item>

              <!-- VCF Code -->
              <!-- 刪除欄位 -->
              <!-- <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="vcfCode">{{ 'table.VCFCode' | translate }}</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                      <input nz-input id="vcfCode" placeholder="{{ 'table.VCFCode' | translate }}" maxlength="10" />
                    </nz-form-control>
                  </nz-form-item> -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="guestVendorCode">{{ 'table.GuestVendorCode' | translate }}
                </nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24" class="custom-width">
                  <nz-select id="guestVendorCode" style="border-radius:6px;"
                    nzPlaceHolder="{{'table.GuestVendorCode' | translate}}" [nzAllowClear]="true"
                    [nzShowSearch]="true" [(ngModel)]="guestVendorCodeValue" name="guestVendorCode"
                    (ngModelChange)="onGuestVendorCodeSelect($event)">
                    <nz-option [nzValue]="''" nzLabel="-"></nz-option>
                    <nz-option *ngFor="let option of guestVendorCodeOptions" [nzLabel]="option.label"
                      [nzValue]="option.value"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
              <!-- 提交按钮占位（后续可接入真实方法） -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon></nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <button type="button" nz-button nzSize="large" nzType="primary" class="custom-submit-button"
                    (click)="submitGuestVendor(); $event.preventDefault()" [nzLoading]="isSubmitting">{{ 'Submit' |
                    translate }}</button>
                </nz-form-control>
              </nz-form-item>

            </form>
          </div>
        </nz-tab>

        <!-- Tab 3: 来宾客户/回收商 (模板示例，字段待确认) -->
        <nz-tab nzTitle="{{ 'GuestCustomerRegister' | translate }}">
          <form nz-form [formGroup]="guestCustomerForm" (ngSubmit)="submitGuestCustomerForm()" class="register-form guest-customer-form">
            <div class="move-right-container">
              <!-- <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'ContactList.GuestCode' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                  <div style="display:flex; gap:8px; align-items:center; width:100%;">
                    <input formControlName="guestCustomerCode" nz-input class="full-width-other" />
                    <button nz-button nzType="default" type="button" (click)="searchGuestCustomerByCode()"
                      [disabled]="loading">{{ 'Query' | translate }}</button>
                  </div>
                </nz-form-control>
              </nz-form-item> -->

              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'GuestCustomerName' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="{{ 'EnterGuestCustomerName' | translate }}">
                  <input formControlName="customerName" nz-input class="full-width-other" placeholder="{{ 'table.VendorName' | translate }}" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'GuestCustomerBackground' | translate }}<span
                    nz-tooltip nzTooltipTitle="{{ 'BackgroundTip' | translate }}" nz-icon nzType="info-circle"
                    nzTheme="twotone"></span></nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input formControlName="background" nz-input class="full-width-other" placeholder="{{ 'table.Background' | translate }}" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'GuestCustomerAddress' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input formControlName="customerAddress" nz-input class="full-width-other" placeholder="{{ 'table.VendorAddress' | translate }}" />
                </nz-form-control>
              </nz-form-item>
              <!-- 先不顯示該欄位 -->
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'GuestContactChineseName' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input formControlName="contactChineseName" nz-input class="full-width-other" placeholder="{{ 'table.ContactChineseName' | translate }}" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'GuestContactEnglishName' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="{{ 'EnterEnglishName' | translate }}">
                  <input formControlName="contactEnglishName" nz-input class="full-width-other" placeholder="{{ 'table.ContactEnglishName' | translate }}" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'GuestContactMobile' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input formControlName="contactMobile" nz-input class="full-width-other" placeholder="{{ 'table.ContactMobile' | translate }}" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzNoColon>{{ 'GuestContactEmail' | translate
                  }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="{{ 'EnterEmail' | translate }}">
                  <input formControlName="contactEmail" nz-input class="full-width-other" placeholder="{{ 'table.ContactEmail' | translate }}" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon>{{ 'table.ContactCompanyPhone' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <input formControlName="companyPhone" nz-input class="full-width-other" placeholder="{{ 'table.ContactCompanyPhone' | translate }}" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="guestCustomerGuestVendorCode">{{ 'table.GuestVendorCode' | translate }}</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <nz-select id="guestCustomerGuestVendorCode"
                    nzPlaceHolder="{{ 'table.GuestVendorCode' | translate }}" [nzAllowClear]="true"
                    [nzShowSearch]="true" [(ngModel)]="guestCustomerCodeSelectValue" name="guestCustomerCodeSelectValue"
                    [ngModelOptions]="{ standalone: true }" (ngModelChange)="onGuestCustomerCodeSelect($event)">
                    <nz-option [nzValue]="''" nzLabel="-"></nz-option>
                    <nz-option *ngFor="let option of guestCustomerCodeOptions" [nzLabel]="option.label"
                      [nzValue]="option.value"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzNoColon></nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                  <button nz-button nzNativeType="submit" nzSize="large" nzType="primary" class="custom-submit-button">{{ 'Submit' | translate
                  }}</button>
                </nz-form-control>
              </nz-form-item>
            </div>
          </form>
        </nz-tab>
      </nz-tabset>
    </nz-card>
  </div>
</nz-spin>
